import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import * as _ from "lodash";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { GridOptionModel } from "../models/shared/gridOption";
import { GuidItemModel } from "../models/shared/guidItem";
import { AutomationModel } from "../models/automation/automationDTO";
import { AutomationDetailsModel } from "../models/automation/automationDetailsDTO";
import { AutomationHistoryModel } from "../models/automation/automationHistoryDTO";
let AutomationsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    let AutomationsModule = class AutomationsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "Automation";
            this.totalCount = 0;
            this.organizations = [];
            this.savedSearchItems = [];
            this.searchParams = null;
            this.automations = [];
            this.automation = null;
            this.automationlog = null;
        }
        async GetAutomationDefaults() {
            var url = `${getTenantId()}/${this.apiNode}/defaults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetOrganizations(plainToClass(GuidItemModel, data.organizations));
                this.SetSaveSearches(plainToClass(GuidItemModel, data.savedSearchItems));
                return data;
            }
        }
        async SaveAutomation(payload) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, payload);
            if (data) {
                return data;
            }
        }
        async EditAutomation(payload) {
            var url = `${getTenantId()}/${this.apiNode}/edit`;
            let { data } = await service.post(url, payload);
            if (data) {
                return data;
            }
        }
        async GetAutomations(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetAutomations(plainToClass(AutomationModel, data.automations));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async GetAutomationDetailById(automationId) {
            var url = `${getTenantId()}/${this.apiNode}/` + automationId;
            let { data } = await service.get(url);
            if (data) {
                this.SetAutomationLog(plainToClass(AutomationHistoryModel, data.automationLog));
                return data;
            }
        }
        async ArchiveAutomationById(automationId) {
            var url = `${getTenantId()}/${this.apiNode}/archive/` + automationId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        SetAutomationLog(automationlog) {
            this.automationlog = automationlog;
        }
        SetOrganizations(organizations) {
            this.organizations = organizations;
        }
        SetSaveSearches(savedSearchItems) {
            this.savedSearchItems = savedSearchItems;
        }
        AssignSearchParams(param) {
            this.searchParams = _.cloneDeep(param);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
        async SetTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
        async SetAutomations(automations) {
            this.automations = automations;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], AutomationsModule.prototype, "GetAutomationDefaults", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof AutomationDetailsModel !== "undefined" && AutomationDetailsModel) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], AutomationsModule.prototype, "SaveAutomation", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof AutomationDetailsModel !== "undefined" && AutomationDetailsModel) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], AutomationsModule.prototype, "EditAutomation", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof GridOptionModel !== "undefined" && GridOptionModel) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], AutomationsModule.prototype, "GetAutomations", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], AutomationsModule.prototype, "GetAutomationDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Guid !== "undefined" && Guid) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], AutomationsModule.prototype, "ArchiveAutomationById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof AutomationHistoryModel !== "undefined" && AutomationHistoryModel) === "function" ? _l : Object]),
        __metadata("design:returntype", void 0)
    ], AutomationsModule.prototype, "SetAutomationLog", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AutomationsModule.prototype, "SetOrganizations", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AutomationsModule.prototype, "SetSaveSearches", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof GridOptionModel !== "undefined" && GridOptionModel) === "function" ? _m : Object]),
        __metadata("design:returntype", void 0)
    ], AutomationsModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AutomationsModule.prototype, "ClearSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], AutomationsModule.prototype, "SetTotalCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], AutomationsModule.prototype, "SetAutomations", null);
    AutomationsModule = __decorate([
        Module({ dynamic: true, store: store, name: "automation", namespaced: true })
    ], AutomationsModule);
    return AutomationsModule;
})();
export const AutomationModule = getModule(AutomationsModule);
